import React, { useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Col, Row, Form, Container, Button, Spinner, Image } from 'react-bootstrap'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate } from 'react-router-dom'
import { IMaskInput } from 'react-imask'
import UserCircle from '../../../../assets/UserCircle.svg'
import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'

const AtendentesNovo: React.FC = () => {
  const [name, setName] = useState<string>('')
  const [gender, setGender] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [birth, setBirth] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [password_confirmation, setPassword_confirmation] = useState<string>('')

  const [profilePicture, setProfilePicture] = useState<File | null>()

  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  const clearFileInput = (e: any) => {
    const filesData = new DataTransfer()
    e.target.files = filesData.files
  }

  const handlePictureChange = (e: any) => {
    if (e.target.files) {
      const file = e.target.files[0]
      const fileType = file.name.split('.')[1].toLowerCase()

      if (!['jpg', 'png', 'gif', 'jpeg'].includes(fileType)) {
        toast.error('A foto deve possuir formato .PNG, .JPG, .JPEG ou .GIF')
        clearFileInput(e)
        setProfilePicture(null)
      } else setProfilePicture(e.target.files[0])
    }
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!name || !gender || !phone || !email || !password || !password_confirmation) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }
    if (password !== password_confirmation) {
      toast.error('As senhas devem ser iguais!')
      setIsLoading(false)
      return
    }

    const data = new FormData()
    const model = {
      name,
      gender,
      phone,
      birth,
      email,
      password,
      password_confirmation,
    }
    data.append('data', JSON.stringify(model))
    if (profilePicture) data.append('image', profilePicture, profilePicture.name)

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    try {
      await api.post('/company/attendants', data, config)
      toast.info('Atendente cadastrado com sucesso!', {
        autoClose: 3000,
      })
      setIsLoading(false)
      navigate('/empresa/atendentes')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar o atendente! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return name && gender && phone && email && password && password_confirmation
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Cadastrar atendente">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Novo Atendente</h2>
        <Col style={{ textAlign: 'center' }}>
          <Image
            style={{ height: 150, width: 150, borderRadius: 12 }}
            fluid={true}
            src={profilePicture ? URL.createObjectURL(profilePicture) : UserCircle}
          />
        </Col>
        <Col className={styles.form_container}>
          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Nome*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Foto de perfil (opcional)
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="file"
                placeholder="Selecione a foto de perfil"
                onChange={(event) => {
                  handlePictureChange(event)
                }}
              />
            </Col>
          </Row>

          <Row style={{ textAlign: 'left' }}>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Gênero*
              </Form.Label>
              <Form.Select
                className={styles.input}
                value={gender}
                onChange={(event) => setGender(event.target.value)}
              >
                <option value="">Selecione o gênero</option>
                <option value="male">Masculino</option>
                <option value="female">Feminino</option>
                <option value="other">Outro</option>
              </Form.Select>
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Telefone*
              </Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask={[
                  { mask: '(00) 00000000' }, // para números fixos (8 dígitos)
                  { mask: '(00) 000000000' }, // para números de celular (9 dígitos)
                ]}
                placeholder="Digite aqui o telefone"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Data de nascimento
              </Form.Label>
              <Form.Control
                className={styles.input}
                value={birth}
                type="date"
                onChange={(event) => setBirth(event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                E-mail*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o e-mail"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Col>
          </Row>

          <Row
            style={{
              paddingBottom: 12,
              textAlign: 'left',
            }}
          >
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Col>
            <Col md={6} style={{ marginTop: 15 }}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Repita a senha*
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="password"
                placeholder="Digite a senha"
                value={password_confirmation}
                onChange={(event) => setPassword_confirmation(event.target.value)}
              />
            </Col>
          </Row>
          <Col style={{ textAlign: 'right' }}>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Cadastrar atendente'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
    </DashboardLayout>
  )
}

export default AtendentesNovo
